import React from 'react';
import { ThumbsUp, MessageCircle, BarChart3, MoreVertical, Users } from 'lucide-react';
import { Avatar } from '../Avatar';
import { sanitizeBrandText } from '../../../utils/helpers';
import styles from './Card.module.css';

export interface AssistantCardProps {
  id: string;
  name: string;
  author: string;
  description: string;
  avatar?: string;
  likes: number;
  comments: number;
  totalUses: number;
  isShared?: boolean;
  onClick?: () => void;
  onMenuClick?: (e: React.MouseEvent) => void;
}

export const AssistantCard: React.FC<AssistantCardProps> = ({
  name,
  author,
  description,
  avatar,
  likes,
  comments,
  totalUses,
  isShared = true,
  onClick,
  onMenuClick,
}) => {
  const formatNumber = (num: number): string => {
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  return (
    <div className={styles.card} onClick={onClick} role="button" tabIndex={0}>
      <div className={styles.cardHeader}>
        <Avatar src={avatar} name={name} size="lg" />
        <div className={styles.cardInfo}>
          <h3 className={styles.cardTitle}>{name}</h3>
          <p className={styles.cardAuthor}>by {sanitizeBrandText(author)}</p>
        </div>
      </div>
      
      <p className={styles.cardDescription}>{description}</p>
      
      <div className={styles.cardFooter}>
        <div className={styles.cardStats}>
          <div className={styles.statItem} title="Chat">
            <span className={styles.chatIcon}>💬</span>
          </div>
          <div className={styles.statItem} title="Likes">
            <ThumbsUp size={14} />
            <span>{likes}</span>
          </div>
          <div className={styles.statItem} title="Comments">
            <MessageCircle size={14} />
            <span>{comments}</span>
          </div>
          <button
            className={styles.menuButton}
            onClick={(e) => {
              e.stopPropagation();
              onMenuClick?.(e);
            }}
            aria-label="More options"
          >
            <MoreVertical size={16} />
          </button>
        </div>
        <div className={styles.cardUsage}>
          <BarChart3 size={14} />
          <span>{formatNumber(totalUses)} total uses</span>
        </div>
      </div>
      
      {!isShared && (
        <div className={styles.sharedStatus}>
          <Users size={14} />
          <span>Not shared</span>
        </div>
      )}
    </div>
  );
};

export default AssistantCard;
